//Wersja embed z 1 Login

let data = {};
let contest = false;

const getUserStatus = function(){
  const qs = '#form__voting_fields, .form__voting_inner, .agrees, .send-vote-onelogin';
  let url = document.querySelector('form');
  if (!url) return;
  url = url.getAttribute('data-status');
  if (!url || url.length < 3) url = '/api/user_status';
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response=>response.json())
    .then((res) => {
      isVotabilityUserStatusChecked = true;
      if (!res.voted) {
        if (!res.registered) {
          contest = true;
          document.querySelectorAll(qs).forEach((elm) => {
            elm.style.display = 'flex';
          });
          if (res.isLogged) {
            document.querySelector('.send-vote-onelogin').innerHTML = 'Zagłosuj i weź udział w konkursie';
            document.querySelector('.send-vote:not(.send-vote-onelogin)').innerHTML = 'Oddaj Głos';
            document.querySelector('.send-vote-onelogin + span').style.display = 'block'; //m +
          } else {
            //jak nie jest zalogowany w embedzie to ukrywamy formularz i robimy buttona przekierowującego do LP
            document.querySelector('.send-vote-onelogin').innerHTML = 'Zagłosuj i weź udział w konkursie'; // m 'Przejdź do formularza głosowania'
            document.querySelector('.send-vote-onelogin + span').style.display = 'block'; //m +
            document.querySelector('.form__voting_inner').style.display = 'none';
            contest = false;
          }
        } else {
          document.querySelector('.send-vote-onelogin').style.display = 'flex';
          if (res.isLogged) {
            document.querySelectorAll('.form__voting_inner, .form__or_separator, .send-vote-onelogin').forEach((elm) => {
              elm.style.display = 'none';
            });
            document.querySelector('h2.article__title').innerHTML = 'Potwierdź oddanie głosu';
            document.querySelector('.send-vote:not(.send-vote-onelogin)').innerHTML = 'Oddaj Głos';            
            //usunąć span po przycisku 
            document.querySelector('.send-vote-onelogin + span').style.display = 'none'; //m +
            document.querySelector('#form__voting_fields').style.display = 'block';

          } else {

            document.querySelectorAll('#form__voting_fields, .voting_cnt h2.article__title, .form__or_separator, .send-vote:not(.send-vote-onelogin)').forEach((elm) => {
              elm.style.display = 'none';
            });
            document.querySelector('.voting_cnt h2.article__title').innerHTML = 'Głosuj z 1Login';
            document.querySelector('.send-vote-onelogin').innerHTML = 'Zagłosuj i weź udział w konkursie'; //m 'Zagłosuj z logowaniem'
            document.querySelector('.send-vote-onelogin + span').style.display = 'block'; //m +

          }
        }
        window.parent.postMessage('TopserialeScrollTo:end', '*');
      } else {
        //komunikat, że głosował już tego dnia
        infobox(`<h2>W wybranej kategorii możesz głosować raz dziennie.</h2>Zapraszamy jutro`);        
      }
      document.querySelector('._ext-votability-unchecked').classList.remove('_ext-votability-unchecked');
      setEmbedSize();
    })
    .catch((err) => {
       //console.log('Error', err);
    });
};

let infobox = (txt) => {
  let ts = -1;
  let infoBox = document.createElement('div');
  infoBox.classList.add('form_infobox');
  infoBox.innerHTML = txt;
  document.body.appendChild(infoBox);
  window.parent.postMessage('TopserialeScrollTo:center', '*');

  function hideInfo(){
      if (ts>-1) clearTimeout(ts);
      infoBox.style.display = 'none';
      document.body.removeChild(infoBox);
      ts = -1;
  }

  //ukrycie komunikatu na kliknięcie
  infoBox.addEventListener('click', e => {
      e.preventDefault();
      hideInfo();
  });
  ts = setTimeout(hideInfo, 1750);

  document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
          hideInfo();
      }
  });
};

(()=>{

    const postLogin = function() {
      const storageData = storage();
       if (!storageData || storageData.length < 9) {
        console.log('1LPost: Nie udało się odzyskać sesji po powrocie z logowania 1L');
        document.location.href = document.location.pathname;
        return;
      };

      data = JSON.parse(storageData);
      if (data.candidate.length<3) {
        console.log('1LPost: Brak kandydata');
        document.location.href = document.location.pathname;
        return;
      };
      sendVote();
      window.localStorage.removeItem('post');
      history.pushState(
        {
          id: document.querySelector('article').id
        },
        data.category,
        /([^?]+)/.exec(document.location.href)[1]
      );
      setEmbedSize();
    };

    const storage = function(dataString) {
      if (dataString) {
        window.localStorage.setItem('post', dataString);
      } else {
        return window.localStorage.getItem('post');
      }
    };

    const sendVote = function() {
      window.parent.postMessage('TSDEBUG:sendVote-start', '*');
      const url = document.querySelector('form').getAttribute('data-url');
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.text())
        .then((html) => {
          if (html.startsWith('h')) {
            data['post_login'] = 1;
            storage(JSON.stringify(data));
            window.parent.postMessage('Login:' + html, '*');
          } else {
            const vC = document.querySelector('form .candidate__select');
            vC.innerHTML = html;
            //ukrywamy przyciski do głosowania
            document.querySelector('#form__voting_fields').style.display = 'none';
            document.querySelector('#description-2').value = '';
            isVotabilityUserStatusChecked = false;
            setEmbedSize();
            window.parent.postMessage('TopserialeScrollTo:end', '*');
            
          }
          window.sessionStorage.clear();
        })
        .catch((err) => {
          // console.log('Error', err);
        });
    };

    const forms = document.querySelectorAll(
      '.form-embedded:not(.form-embedded-loaded)'
    );

    //Sprawdzanie, czy głosowanie się zakończyło
    const titleServed = document.querySelector('h2.candidates-voting__title');
    if (titleServed && titleServed.innerText.indexOf('zakończone') !== -1 ) {
      window.parent.postMessage('TopserialeHideIframe:voting-ended', '*');
      return;
    }

    if (forms.length) {
      forms.forEach((form) => {
        form.classList.add('form-embedded-loaded');
        //const fieldToValidate = form.querySelectorAll('.form-field');
        //const fieldsNotMail = form.querySelectorAll(
        //  '.form-field:not([data-id="email"])'
        //);
        //const mailToValidate = form.querySelector('.form-field[data-id="email"]');
        // const checkboxes = form.querySelectorAll('.form-checkbox');
        //const answer = form.querySelector('textarea.form-field');

        form
          .querySelector('.fieldset__category')
          .addEventListener('click', function (e) {
            const input = this.querySelector('.form-field');
            const selectMenu = this.querySelector('.category__select');
            const selectField = this.querySelector('.category__field');
            selectMenu.classList.toggle('category__select--visible');
            this.classList.toggle('fieldset--active');
            selectMenu.addEventListener('mouseleave', function () {
              selectMenu.classList.remove('category__select--visible');
              selectMenu.closest('fieldset').classList.remove('fieldset--active');
            });
            selectMenu.querySelectorAll('li').forEach((li) => {
              li.addEventListener('click', function () {
                document.location.href = li.dataset.url;                
                return;
                // console.log(this.innerText);
                selectField.innerText = this.innerText;
                input.value = this.getAttribute('data-value');
                //fetch
                if (
                  selectMenu.closest('fieldset').classList.contains('has-error')
                ) {
                  selectMenu.closest('fieldset').classList.remove('has-error');
                }
                fetchCandidates(
                  this.getAttribute('data-url'),
                  form.querySelector('.candidate__select')
                );
              });
              //form.querySelector('.buttons').style.display = 'flex';
            });
          });

        form.querySelector('.candidate__select').addEventListener('click', candidateClick);

        const fieldToValidate = form.querySelectorAll('.form-field');

        document.getElementById('agree-1').addEventListener('change', function () {
          validateCheckbox(this);
        });

        document.getElementById('description-2').addEventListener('keydown', function () {
          validateField(this, 5);
        });



        const submitBtns = form.querySelectorAll('.send-vote');
        data['form_placement'] = 'embed';
        submitBtns.forEach((btn) => {
          btn.addEventListener('click', e => {
            e.preventDefault();

            let formIsValid = true;

            data.category = form
                .querySelector('.form-field[data-id="category"]')
                .value;

            if (
                form.querySelector('.candidate--selected') &&
                form.querySelector('.candidate--selected').getAttribute('data-value')
               ) {
                    data.candidate = form
                        .querySelector('.candidate--selected')
                        .getAttribute('data-value');
                } else {
                  infobox('<h2>Aby oddać głos wybierz serial</h2>');
                  return false;
                }

                if (e.target.classList.contains('send-data')) {
                  storage(JSON.stringify(data));
                  window.parent.postMessage('Login:' + e.target.dataset.url, '*');
                  return; 
                };


                if (btn.classList.contains('send-vote-onelogin')) {
                  let cbx = document.getElementById('agree-1');
                  let dsc = document.getElementById('description-2');

                  if ( contest && (!validateField(dsc, 5) || !validateCheckbox(cbx) )) {
                    formIsValid = false;
                  } else {
                    formIsValid = true;
                  }
                  data.description = document.getElementById('description-2').value;
                  data.button = 'vote_register';
                } else {
                  // tutaj kod bez danych
                  fieldToValidate.forEach((el) => {
                    // jak cos ma error z fieldstovalidate to usun error
                    el.closest('fieldset').classList.remove('has-error');
                    el.closest('fieldset').setAttribute('data-error', '');
                    if (el.value.trim().length > 0) {
                      data[el.getAttribute('data-id')] = el.value;
                    }
                  });
                  data.button = 'vote';
                }

            /*
              // walidacja formularza z danymi
            if (btn.classList.contains('send-data')) {
              fieldsNotMail.forEach((el) => {
                if (!validateField(el, 2)) {
                  formIsValid = false;
                } else {
                  data[el.getAttribute('data-id')] = el.value;
                }
              });
              if (!validateEmail(mailToValidate)) {
                formIsValid = false;
              } else {
                data[mailToValidate.getAttribute('data-id')] =
                  mailToValidate.value;
              }

              checkboxes.forEach((el) => {
                if (!validateCheckbox(el)) {
                  formIsValid = false;
                } else {
                  data[el.getAttribute('data-id')] = el
                    .closest('fieldset')
                    .querySelector('label').innerText;
                }
              });


              data.button = 'vote_register';
            } else {
            //   tutaj kod bez danych
            //   fieldToValidate.forEach((el) => {
            //     // jak cos ma error z fieldstovalidate to usun error
            //     el.closest('fieldset').classList.remove('has-error');
            //     el.closest('fieldset').setAttribute('data-error', '');
            //     if (el.value.trim().length > 0) {
            //       data[el.getAttribute('data-id')] = el.value;
            //     }
            //   });
            //   checkboxes.forEach((el) => {
            //     el.nextElementSibling.classList.remove('has-error');
            //     el.classList.remove('has-error');
            //     if (el.checked) {
            //       data[el.getAttribute('data-id')] = el
            //         .closest('fieldset')
            //         .querySelector('label').innerText;
            //     }
            //   });
              data.button = 'vote';
            }
            */

            if (formIsValid && data.candidate) {
              //createSpinner(form);

              if (btn.classList.contains('send-vote-onelogin')) {
                data.button = 'onelogin';
              } else {
                data.button = 'vote';
              }

              sendVote();

              /* FORMULARZ
              const url = form.getAttribute('data-url');
              fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              })
                .then((response) => response.text())
                .then((html) => {
                  if (html.startsWith('h')) {
                    console.log('Redirect: ', html);
                    document.location.href = html;
                  } else {
                    const vC = form.querySelector('.candidate__select');
                    vC.innerHTML = html;
                    //ukrywamy przyciski do głosowania
                    form.querySelector('.buttons').style.visibility = 'hidden';
                  }
                  window.sessionStorage.clear();
                })
                .catch((err) => {
                  // console.log('Error', err);
                });
              /// KONIEC FORMULARZA */
            }
          });
        });
      });
    }

    //obsługa postlogin - powrót z logowania 1L
    // if (isPostLogin) {
    //   postLogin();
    // }

    // === AUTO HEIGHT INIT ===
    if (typeof setEmbedSize === 'function') {
      setTimeout(setEmbedSize, 100);
      window.addEventListener('load', function() {
        setEmbedSize();
      });
    }

  })();
